import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { API_BASE_URL } from "../helpers/constants";
import AppPageHeader from "../components/AppPageHeader";

function Login() {
  const navigate = useNavigate();
  const { login, user } = useAuth();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  // Check if already logged in
  useEffect(() => {
    if (user) {
      navigate("/account");
    }
  }, [user, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError("Please enter email and password");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const res = await fetch(`${API_BASE_URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Login failed");
      }

      if (data && data.token) {
        login(data.token, {
          user_id: data.user_id,
          email: data.email,
          display_name: data.display_name,
        });
        navigate("/account");
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#fff",
        color: "#2f2f2d",
        fontFamily: "system-ui, -apple-system, Segoe UI, sans-serif",
      }}
    >
      <AppPageHeader title="Login" metaLine="dehisce.com" />

      <main style={{ padding: "16px", maxWidth: "420px", boxSizing: "border-box" }}>
        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: "8px" }}>
            <input
              type="email"
              className="auth-text-input"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <input
              type="password"
              className="auth-text-input"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            type="submit"
            className="auth-primary-button"
            disabled={loading}
          >
            {loading ? "Loading..." : "Login"}
          </button>
        </form>

        {error && (
          <div
            style={{
              padding: "10px 12px",
              marginTop: "16px",
              background: "#fdecec",
              border: "1px solid #e9bcbc",
              color: "#8f1e1e",
              fontSize: "12px",
              lineHeight: 1.35,
            }}
          >
            <strong>Error:</strong> {error}
          </div>
        )}
      </main>
    </div>
  );
}

export default Login;
